import { SVGProps } from "react";

export default function VideoFileIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 16, height = 16, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.0026 14.6663H10.0026C13.3359 14.6663 14.6693 13.333 14.6693 9.99967V5.99967C14.6693 2.66634 13.3359 1.33301 10.0026 1.33301H6.0026C2.66927 1.33301 1.33594 2.66634 1.33594 5.99967V9.99967C1.33594 13.333 2.66927 14.6663 6.0026 14.6663Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.0625 7.99999V7.01333C6.0625 5.73999 6.9625 5.22666 8.0625 5.85999L8.91583 6.35333L9.76917 6.84666C10.8692 7.47999 10.8692 8.51999 9.76917 9.15333L8.91583 9.64666L8.0625 10.14C6.9625 10.7733 6.0625 10.2533 6.0625 8.98666V7.99999Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
